import classNames from "classnames";
import PropTypes from "prop-types";

import { FILE_TYPE } from "Marketing/CMS/enums";

import styles from "./FileTypeIcon.module.css";
import AudioIcon from "./icons/audio.svg";
import DefaultIcon from "./icons/default.svg";
import DocumentIcon from "./icons/document.svg";
import KeynoteIcon from "./icons/keynote.svg";
import LinkIcon from "./icons/link.svg";
import PDFIcon from "./icons/pdf.svg";
import PowerPointIcon from "./icons/powerpoint.svg";
import VideoIcon from "./icons/video.svg";

const fileIcons = {
  [FILE_TYPE.pdf]: PDFIcon,
  [FILE_TYPE.audio]: AudioIcon,
  [FILE_TYPE.video]: VideoIcon,
  [FILE_TYPE.document]: DocumentIcon,
  [FILE_TYPE.ppt]: PowerPointIcon,
  [FILE_TYPE.pps]: PowerPointIcon,
  [FILE_TYPE.keynote]: KeynoteIcon,
  [FILE_TYPE.url]: LinkIcon,
};

/**
 * Displays an icon appropriate for the specified file type.
 */
export function FileTypeIcon({ fileTypeId, className, ...props }) {
  return (
    <img
      {...props}
      className={classNames(styles.icon, className)}
      src={fileIcons[fileTypeId] || DefaultIcon}
    />
  );
}

FileTypeIcon.propTypes = {
  /**
   * A file type ID to determine which icon to display.
   */
  fileTypeId: PropTypes.number.isRequired,

  className: PropTypes.string,
};
